<template>
  <v-container fluid class="pa-0">
    <v-skeleton-loader v-if="!meeting" width="100%" height="100%" type="article, actions, date-picker"></v-skeleton-loader>
    <div v-else>
      <v-card class="mx-auto elevation-2 pa-3" max-width="100%" style="background:#fff">
        <div class="float-left" style="overflow:auto;white-space:nowrap;">
          <div style="float:left;margin-right:20px;height:35px;">
            <v-btn v-for="(r, i) in racesF()" :key="`${r.number}:${i}`" fab x-small :color="navColor(r.number, race.number, r.status, r.results)" class="ml-1 d-inline caption raceButton elevation-2" @click="clickRace(r)">{{r.number}}</v-btn>
          </div>
        </div>
        <div :key="getStatus()" v-if="getStatus() === 'OPEN'" class="float-right text--primary font-weight-medium pr-2">
          <span class="subtitle-2 font-weight-bold" d-inline>To Start ({{ formattedRaceStartTime(parseISO(race.startTime)) }})</span>
          <LiveCountdown :key="race.startTime" :startTime="race.startTime" style="font-size:1.6rem" class="raceTime" />
        </div>
        <div v-else class="text--primary font-weight-medium title float-right pr-2">
          <span class="raceStatusText" style="color:red">{{getStatus()}}</span>
        </div>
        <v-card-text class="pa-1 pb-0">
          <div style="display:flex;flex-wrap:nowrap;flex-direction:row;width:100%;justify-content:space-between;">
            <div class="accent-4 text--primary font-weight-bold mr-4 trackName" style="width:430px; white-space: nowrap;">
              <div :class="'icon-' + meeting.type" style='float:left;margin-top:10px;margin-right:15px;zoom:60%;scale:0.7'></div>
              <div class="d-inline mr-1 title font-weight-bold">{{ trackName }}</div>
              <div class="d-inline title font-weight-bold">{{ raceNum }}</div>
              <CountryFlags class="ml-2" style="margin-top:3px;position:absolute;" :meeting="meeting" :small="false"/>
            </div>
            <div class="d-inline">
              <v-btn x-small color="#fe3d89" class="white--text" @click="regenerateSilks">
                <v-icon small class="mr-1">mdi-refresh</v-icon>
                Regenerate Silks</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <confirm-modal
      :open="modal.open"
      :title="modal.title"
      :message="modal.message"
      :loading="modal.loading"
      confirm-text="Proceed"
      decline-text="Cancel"
      @confirm="modal.onConfirm"
      @decline="modal.onDecline"
    />
    <v-dialog v-model="dialogSetRaceTime" scrollable max-width="400px">
      <v-card style="height: 400px;">
        <v-card-title>Change Time</v-card-title>
        <v-card-text>
          <v-radio-group v-model="optionSetRaceTime" column>
            <v-radio label="Adjust start time" value="minutes"></v-radio>
            <v-radio label="Set start time" value="startTime"></v-radio>
          </v-radio-group>
          <span v-if="optionSetRaceTime === 'minutes'">Set the number of minutes to adjust the start time by. Will adjust all ongoing races.</span>
            <span v-else-if="optionSetRaceTime === 'startTime'">Must be in Darwin Time. Will only affect this race.</span>
          <v-text-field v-if="optionSetRaceTime === 'minutes'" v-model="minutes" label="Number of minutes" type="number" min="0"></v-text-field>
          <vue-timepicker manual-input v-else-if="optionSetRaceTime === 'startTime'" format="HH:mm" v-model="raceTime" style="margin-top: 10px;"></vue-timepicker>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text @click="dialogSetRaceTime = false">Cancel</v-btn>
          <v-btn 
            color="success" 
            text 
            @click="handleSetRaceTimeConfirm()" 
            :disabled="((optionSetRaceTime === '') || (optionSetRaceTime === 'minutes' && minutes === '') || (optionSetRaceTime === 'startTime' && raceTime === ''))"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSetResults" scrollable max-width="300px">
      <v-card>
        <v-card-title>Set Results</v-card-title>
        <v-card-text>
          <span>If there is a deadheat, seperate runners with a comma</span>
          <v-text-field label="Firsts" v-model="firsts"></v-text-field>
          <v-text-field label="Seconds" v-model="seconds"></v-text-field>
          <v-text-field label="Third" v-model="third"></v-text-field>
          <v-text-field label="Fourths" v-model="fourths"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text @click="dialogSetResults = false">Cancel</v-btn>
          <v-btn 
            color="success" 
            text 
            @click="handleSetDividendsClick()"
            :disabled="firsts === '' && seconds === '' && third === '' && fourths === ''"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSelectBookie" scrollable max-width="300px">
      <v-card>
        <v-card-title>Select Bookie</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-radio-group v-model="selectedBookie" column>
            <v-radio label="All" value=""></v-radio>
            <v-radio v-for="b in bookies" :key="b.gbsCode" :label="b.name" :value="b.gbsCode"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="dialogSelectBookie = false">Cancel</v-btn>
          <v-btn color="success" text @click="handleResendPricesConfirm()" :disabled="selectedBookie === ''">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSetDividends" scrollable max-width="400px">
      <v-card>
        <v-card-title>Set Dividends</v-card-title>
        <v-card-text>
          <span>Any dividends left as zero won't be sent.</span>
          <v-data-table :items="runnersPositions" hide-default-footer :headers="headersDividends" multi-sort :items-per-page=9999>
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.betType }}</td>
                <td align="center">{{ item.combination }}</td>
                <td>
                  <v-text-field v-model="item.dividend" :name="item.betType + '-' + item.combination" type="number" min="0"></v-text-field>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text @click="dialogSetDividends = false">Cancel</v-btn>
          <v-btn 
            color="success" 
            text 
            @click="handleSetResultsConfirm()" 
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapActions, mapGetters, mapState } from 'vuex'
import CountryFlags from './CountryFlags'
import ConfirmModal from "../components/ConfirmModal"
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import { formattedRaceStartTime } from '../common/methods'
import LiveCountdown from './LiveCountdown'

export default {
  name: 'RaceHeader',
  data: () => ({
    time: 0,
    raceResultsTable: false,
    raceNotes: false,
    azList: false,
    resultsColumns: {},
    showThereIsNotes: false,
    message: '',
    showLoginModal: false,
    loginTools: true,
    dialogSetRaceTime: false,
    dialogSetResults: false,
    optionSetRaceTime: '',
    raceTime: '',
    minutes: '',
    selectedBookie: '',
    firsts: '',
    seconds: '',
    third: '',
    fourths: '',
    dialogSelectBookie: false,
    dialogSetDividends: false,
    runnersPositions: [],
    modal: {
      open: false,
      title: '',
      message: '',
      loading: false,
      onConfirm: () => {},
      onDecline: () => {},
    },
    headersDividends: [
      {
        text: 'BetType',
        value: 'betType'
      },
      {
        text: 'Combination',
        value: 'combination'
      },
      {
        text: 'Dividend',
        value: 'dividend'
      }
    ]
  }),
  components: {
    CountryFlags,
    ConfirmModal,
    VueTimepicker,
    LiveCountdown
  },
  computed: {
    ...mapGetters(['getSelectedRace', 'getRaceCompetitors', 'getRaceDetails', 'getSelectedMeeting', 'getSelectedMeetingsRaces']),
    ...mapState(['selectedRace', 'races', 'bookies']),
    race: function () {
      return this.getSelectedRace()
    },
    meeting: function () {
      return this.getSelectedRace()?.meeting
    },
    trackName: function () {
      return `${this.meeting.track.name}`
    },
    raceNum: function () {
      return `R${this.race.number}`
    },
    status: function () {
      return this.race?.status
    }
  },
  methods: {
    ...mapActions(['selectRace', 'selectNavRace', 'selectRaceNav', 'fetchBookies', 'auditsByRaceNumber', 'closeRace', 'abandonRaces', 'abandonMeeting', 'setTimeRace', 'resendPrices', 'setRaceResults', 'regenerateRaceSilks']),
    ...mapGetters(['getSessionId']),
    formattedRaceStartTime,
    parseISO,
    clickRace (r) {
      this.selectRace({ id: r.id, idChanged: true })
      this.selectNavRace({ id: r.id })
      this.selectRaceNav(1)
    },
    navColor: function (mappedNumber, raceNumber, raceStatus) {
      if (mappedNumber === raceNumber) {
        return 'normal'
      } else if (raceStatus === 'OPEN') {
        return 'success'
      } else {
        return 'error'
      }
    },
    racesF () {
      return this.getSelectedMeetingsRaces
    },
    getStatus () {
      return this.race.status
    },
    closeModal() {
      this.setModal({ loading: false, open: false, onConfirm: () => {}, onDecline: () => {}, })
    },
    setModal(newState = {}) {
      this.modal = { ...this.modal, ...newState }
    },
    handleCloseRaceClick() {
      this.setModal({
        open: true,
        title: 'Close Race',
        message: `You are about to close ${this.race.meeting.track.name} R${this.race.number}. Would you like to proceed ?`,
        onConfirm: this.handleCloseRaceConfirm,
        onDecline: this.closeModal
      });
    },
    async handleCloseRaceConfirm() {
      this.setModal({ loading: true })
      await this.closeRace()
      this.closeModal()
      this.auditsByRaceNumber()
    },
    handleAbandonRacesClick() {
      this.setModal({
        open: true,
        title: 'Abandon Race',
        message: `You are about to abandon ${this.race.meeting.track.name} R${this.race.number} race. Would you like to proceed ?`,
        onConfirm: this.handleAbandonRacesConfirm,
        onDecline: this.closeModal
      });
    },
    async handleAbandonRacesConfirm() {
      this.setModal({ loading: true })
      await this.abandonRaces()
      this.closeModal()
      this.auditsByRaceNumber()
    },
    handleAbandonMeetingClick() {
      this.setModal({
        open: true,
        title: 'Abandon Meeting',
        message: `You are about to abandon this meeting. Would you like to proceed ?`,
        onConfirm: this.handleAbandonMeetingConfirm,
        onDecline: this.closeModal
      });
    },
    async handleAbandonMeetingConfirm() {
      this.setModal({ loading: true })
      await this.abandonMeeting()
      this.closeModal()
      this.auditsByRaceNumber()
    },
    handleSetRaceTimeClick() {
      this.raceTime = format(parseISO(this.race.startTime), 'HH:mm')
      this.dialogSetRaceTime = true
    },
    async handleSetRaceTimeConfirm() {
      this.setModal({ loading: true });
      await this.setTimeRace({ optionSelected: this.optionSetRaceTime, newTime: this.raceTime, minutes: this.minutes })
      this.dialogSetRaceTime = false
      this.raceTime = ''
      this.optionSetRaceTime = ''
      this.minutes = ''
      this.auditsByRaceNumber()
    },
    handleSetResultsClick() {
      this.runnersPositions = []
      this.firsts = ''
      this.seconds = ''
      this.third = ''
      this.fourths = ''
      this.dialogSetResults = true
    },
    handleSetDividendsClick() {
      this.dialogSetResults = false

      this.firsts = this.firsts.replace(/ /g, "").split(',').filter(function(value){
        return value !== ''
      })
      for (let index = 0; index < this.firsts.length; index++) {
        this.runnersPositions.push({
          betType: 'StartingPrice',
          combination: this.firsts[index],
          dividend: 0
        })
      }

      this.seconds = this.seconds.replace(/ /g, "").split(',').filter(function(value){
        return value !== ''
      })
      for (let index = 0; index < this.seconds.length; index++) {
        this.runnersPositions.push({
          betType: 'StartingPrice',
          combination: this.seconds[index],
          dividend: 0
        })
      }

      this.third = this.third.replace(/ /g, "").split(',').filter(function(value){
        return value !== ''
      })
      for (let index = 0; index < this.third.length; index++) {
        this.runnersPositions.push({
          betType: 'StartingPrice',
          combination: this.third[index],
          dividend: 0
        })
      }

      this.fourths = this.fourths.replace(/ /g, "").split(',').filter(function(value){
        return value !== ''
      })
      for (let index = 0; index < this.fourths.length; index++) {
        this.runnersPositions.push({
          betType: 'StartingPrice',
          combination: this.fourths[index],
          dividend: 0
        })
      }

      //START EXACTA AND QUINELLA
      if(this.firsts.length === 1 && this.seconds.length === 1) {
        var exacta = this.firsts[0] + ', ' + this.seconds[0]
        this.runnersPositions.push({
          betType: 'Exacta',
          combination: exacta,
          dividend: 0
        })

        this.runnersPositions.push({
          betType: 'Quinella',
          combination: exacta,
          dividend: 0
        })
      } else if(this.firsts.length > 1) {
        this.firsts.forEach(one => {
          this.firsts.forEach(two => {
            if(one !== two) {
              this.runnersPositions.push({
                betType: 'Exacta',
                combination: one + ', ' + two,
                dividend: 0
              })
            }
          })
        })

        for (var x = 0; x < this.firsts.length - 1; x++) {
          for (var y = 1; y < this.firsts.length; y++) {
            if(x !== y) {
              this.runnersPositions.push({
                betType: 'Quinella',
                combination: this.firsts[x] + ', ' + this.firsts[y],
                dividend: 0
              })
            }
          }
        }
      } else if(this.firsts.length === 1 && this.seconds.length > 1) {
        var valuesArray = this.firsts.concat(this.seconds)
        for (var i = 0; i < valuesArray.length - 1; i++) {
          this.runnersPositions.push({
            betType: 'Exacta',
            combination: valuesArray[0] + ', ' + valuesArray[i+1],
            dividend: 0
          })
        }

        for (var j = 0; j < valuesArray.length - 1; j++) {
          this.runnersPositions.push({
            betType: 'Quinella',
            combination: valuesArray[0] + ', ' + valuesArray[j+1],
            dividend: 0
          })
        }
      }
      //END EXACTA 
      //--------------------------------------
      //START TRIFECTA
      if(this.firsts.length > 1 && this.seconds.length === 0 && this.third.length > 1) {
        this.firsts.forEach(one => {
          this.firsts.forEach(two => {
            this.third.forEach(three => {
              if(one !== two && two !== three) {
                this.runnersPositions.push({
                  betType: 'Trifecta',
                  combination: one + ', ' + two + ', ' + three,
                  dividend: 0
                })
              }
            })
          })
        })
      } else if (this.firsts.length === 1 && this.seconds.length > 1 && this.third.length === 0) {
        this.firsts.forEach(one => {
          this.seconds.forEach(two => {
            this.seconds.forEach(three => {
              if(one !== two && two !== three) {
                this.runnersPositions.push({
                  betType: 'Trifecta',
                  combination: one + ', ' + two + ', ' + three,
                  dividend: 0
                })
              }
            })
          })
        })
      } else if (this.firsts.length === 1 && this.seconds.length === 1 && this.third.length >= 1) {
        this.firsts.forEach(one => {
          this.seconds.forEach(two => {
            this.third.forEach(three => {
              if(one !== two && two !== three) {
                this.runnersPositions.push({
                  betType: 'Trifecta',
                  combination: one + ', ' + two + ', ' + three,
                  dividend: 0
                })
              }
            })
          })
        })
      }
      //END TRIFECTA 
      //--------------------------------------
      //START FIRSTFOUR
      if(this.firsts.length > 1 && this.seconds.length === 0 && this.third.length >= 1 && this.fourths.length === 0) {
        this.firsts.forEach(one => {
          this.firsts.forEach(two => {
            this.third.forEach(three => {
              this.third.forEach(four => {
                if(one !== two && two !== three && three != four) {
                  this.runnersPositions.push({
                    betType: 'FirstFour',
                    combination: one + ', ' + two + ', ' + three + ', ' + four,
                    dividend: 0
                  })
                }
              })
            })
          })
        })
      } else if(this.firsts.length === 1 && this.seconds.length >= 1 && this.third.length === 0 && this.fourths.length >= 1) {
        this.firsts.forEach(one => {
          this.seconds.forEach(two => {
            this.seconds.forEach(three => {
              this.fourths.forEach(four => {
                if(one !== two && two !== three && three != four) {
                  this.runnersPositions.push({
                    betType: 'FirstFour',
                    combination: one + ', ' + two + ', ' + three + ', ' + four,
                    dividend: 0
                  })
                }
              })
            })
          })
        })
      } else if(this.firsts.length === 1 && this.seconds.length === 1 && this.third.length === 1 && this.fourths.length === 1) {
        this.firsts.forEach(one => {
          this.seconds.forEach(two => {
            this.third.forEach(three => {
              this.fourths.forEach(four => {
                if(one !== two && two !== three && three != four) {
                  this.runnersPositions.push({
                    betType: 'FirstFour',
                    combination: one + ', ' + two + ', ' + three + ', ' + four,
                    dividend: 0
                  })
                }
              })
            })
          })
        })
      } else if(this.firsts.length === 1 && this.seconds.length === 1 && this.third.length > 1 && this.fourths.length === 0) {
        this.firsts.forEach(one => {
          this.seconds.forEach(two => {
            this.third.forEach(three => {
              this.third.forEach(four => {
                if(one !== two && two !== three && three != four) {
                  this.runnersPositions.push({
                    betType: 'FirstFour',
                    combination: one + ', ' + two + ', ' + three + ', ' + four,
                    dividend: 0
                  })
                }
              })
            })
          })
        })
      }
      //END FISTFOUR
      this.dialogSetDividends = true
    },
    async handleSetResultsConfirm() {
      await this.setRaceResults({firsts: this.firsts, seconds: this.seconds, third: this.third, fourths: this.fourths, dividends: this.runnersPositions})
      this.dialogSetDividends = false
      this.auditsByRaceNumber()
    },
    handleResendPricesClick() {
      this.fetchBookies()
      this.dialogSelectBookie = true
    },
    async handleResendPricesConfirm() {
      await this.resendPrices({bookie: this.selectedBookie})
      this.selectedBookie = ''
      this.dialogSelectBookie = false
      this.auditsByRaceNumber()
    },
    regenerateSilks() {
      this.regenerateRaceSilks()
    }
  }
}
</script>

<style>
.icon-HarnessRacing {
  width: 60px;
  height: 30px;
  background: url('~@/assets/race_types/DO_RaceTypeSprite_lrgBlack.png') 0 -65px;
}
.icon-GreyHoundRacing {
  width: 60px;
  height: 30px;
  background: url('~@/assets/race_types/DO_RaceTypeSprite_lrgBlack.png') 0 -130px;
}
.icon-HorseRacing {
  width: 60px;
  height: 30px;
  background: url('~@/assets/race_types/DO_RaceTypeSprite_lrgBlack.png') 0 -0px;
}
.icon-HARNESS {
  width: 60px;
  height: 30px;
  background: url('~@/assets/race_types/DO_RaceTypeSprite_lrgBlack.png') 0 -65px;
}
.icon-GREYHOUND {
  width: 60px;
  height: 30px;
  background: url('~@/assets/race_types/DO_RaceTypeSprite_lrgBlack.png') 0 -130px;
}
.icon-THOROUGHBRED {
  width: 60px;
  height: 30px;
  background: url('~@/assets/race_types/DO_RaceTypeSprite_lrgBlack.png') 0 -0px;
}
</style>
